export default [
  {
    "id": "mat-enem-0728",
    "numero": 2228,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "Um dos grandes desafios do Brasil é o gerenci-\namento dos seus recursos naturais, sobretudo \nos recursos hídricos. Existe uma demanda cres-\ncente por água e o risco de racionamento não \npode ser descartado. O nível de água de um \nreservatório foi monitorado por um período, \nsendo o resultado mostrado no gráfico. Supo-\nnha que essa tendência linear observada no \nmonitoramento se prolongue pelos próximos \nmeses. \n \n \n \nNas condições dadas, qual o tempo mínimo, \napós o sexto mês, para que o reservatório atinja \no nível zero de sua capacidade? \nA) 2 meses e meio. \nB) 3 meses e meio. \nC) 1 mês e meio. \nD) 4 meses. \nE) 1 mês.",
    "alternativas": {
      "E": "1 mês.",
      "A": "2 meses e meio.",
      "B": "3 meses e meio.",
      "C": "1 mês e meio."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 728,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0729",
    "numero": 2229,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "Um posto de saúde registrou a quantidade de \nvacinas aplicadas contra febre amarela nos \núltimos cinco meses: \n \n• 1° mês: 21; \n• 2° mês: 22; \n• 3° mês: 25; \n• 4° mês: 31; \n• 5° mês: 21. \n \nNo início do primeiro mês, esse posto de saúde \ntinha 228 vacinas contra febre amarela em es-\ntoque. A política de reposição do estoque prevê \na aquisição de novas vacinas, no início do sexto \nmês, de tal forma que a quantidade inicial em \nestoque para os próximos meses seja igual a 12 \nvezes a média das quantidades mensais dessas \nvacinas aplicadas nos últimos cinco meses. \n \nPara atender essas condições, a quantidade de \nvacinas contra febre amarela que o posto de \nsaúde deve adquirir no início do sexto mês é: \n \nA) 156. \nB) 180. \nC) 192. \nD) 264. \nE) 288.",
    "alternativas": {
      "D": "264.",
      "A": "156.",
      "B": "180.",
      "C": "192."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 729,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0730",
    "numero": 2230,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "Uma liga metálica sai do forno a uma tempera-\ntura de 3000°C e diminui 1% de sua temperatu-\nra a cada 30 min. \n \nUse 0,477 como aproximação para log10(3) e \n1,041 como aproximação para log10(11). \n \nO tempo decorrido, em hora, até que a liga atin-\nja 30°C é mais próximo de: \n \nA) 22. \nB) 50. \nC) 100. \nD) 200. \nE) 400.",
    "alternativas": {
      "E": "400.",
      "B": "50.",
      "C": "100.",
      "D": "200."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 730,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0731",
    "numero": 2231,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "Um petroleiro possui reservatório em formato de \num paralelepípedo retangular com as dimen-\nsões dadas por 60 m x 10 m de base e 10 m de \naltura. Com o objetivo de minimizar o impacto \nambiental de um eventual vazamento, esse \nreservatório é subdividido em três compartimen-\ntos, A, B e C, de mesmo volume, por duas pla-\ncas de aço retangulares com dimensões de 7 m \nde altura e 10 m de base, de modo que os com-\npartimentos são interligados, conforme a figura. \nAssim, caso haja rompimento no casco do re-\nservatório, apenas uma parte de sua carga va-\nzará. \n \n \n \nSuponha que ocorra um desastre quando o \npetroleiro se encontra com sua carga máxima: \nele sofre um acidente que ocasiona um furo no \nfundo do compartimento C. Para fins de cálculo, \nconsidere desprezíveis as espessuras das pla-\ncas divisórias. \n \nApós o fim do vazamento, o volume de petróleo \nderramado terá sido de: \n \nA) 1,4 x103 m3 \nB) 1,8 x 103 m3 \nC) 2,0 x 103 m3 \nD) 3,2 x 103 m3 \nE) 6,0 x 103 m3",
    "alternativas": {
      "A": "1,4 x103 m3",
      "C": "2,0 x 103 m3",
      "D": "3,2 x 103 m3",
      "E": "6,0 x 103 m3"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 731,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0732",
    "numero": 2232,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "Um adolescente vai a um parque de diversões \ntendo, prioritariamente, o desejo de ir a um brin-\nquedo que se encontra na área IV, dentre as \náreas I, II, III, IV e V existentes. O esquema \nilustra o mapa do parque, com a localização da \nentrada, das cinco áreas com os brinquedos \ndisponíveis e dos possíveis caminhos para se \nchegar a cada área. O adolescente não tem \nconhecimento do mapa do parque e decide ir \ncaminhando da entrada até chegar à área IV. \n \nSuponha que relativamente a cada ramificação, \nas opções existentes de percurso pelos cami-\nnhos apresentem iguais probabilidades de esco-\nlha, que a caminhada foi feita escolhendo ao \nacaso os caminhos existentes e que, ao tornar \num caminho que chegue a uma área distinta da \nIV, o adolescente necessariamente passa por \nela ou retorna. \n \nNessas condições, a probabilidade de ele che-\ngar à área IV sem passar por outras áreas e \nsem retornar é igual a: \n \nA) 1/96 \nB) 1/64 \nC) 5/24 \nD) 1/4 \nE) 5/12",
    "alternativas": {
      "B": "1/64",
      "C": "5/24",
      "E": "5/12",
      "A": "1/96"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 732,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0733",
    "numero": 2233,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "Em uma cidade, o número de casos de dengue \nconfirmados aumentou consideravelmente nos \núltimos dias. A prefeitura resolveu desenvolver \numa ação contratando funcionários para ajudar \nno combate à doença, os quais orientarão os \nmoradores a eliminarem criadouros do mosquito \nAedes aegypti, transmissor da dengue. A tabela \napresenta o número atual de casos confirma-\ndos, por região da cidade. \n \n \n \nA prefeitura optou pela seguinte distribuição dos \nfuncionários a serem contratados: \n \nI. 10 funcionários para cada região da ci-\ndade cujo número de casos seja maior \nque a média dos casos confirmados. \n \nII. 7 funcionários para cada região da ci-\ndade cujo número de casos seja menor \nou igual à média dos casos confirma-\ndos. \n \nQuantos funcionários a prefeitura deverá contra-\ntar para efetivar a ação? \n \nA) 59 \nB) 65 \nC) 68 \nD) 71 \nE) 80",
    "alternativas": {
      "B": "65",
      "C": "68",
      "D": "71",
      "A": "59"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 733,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0734",
    "numero": 2234,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "Cinco marcas de pão integral apresentam as \nseguintes concentrações de fibras (massa de \nfibra por massa de pão): \n \n• Marca A: 2 g de fibras a cada 50 g de pão; \n• Marca B: 5 g de fibras a cada 40 g de pão; \n• Marca C: 5 g de fibras a cada 100 g de pão; \n• Marca D: 6 g de fibras a cada 90 g de pão; \n• Marca E: 7 g de fibras a cada 70 g de pão. \n \nRecomenda-se a ingestão do pão que possui a \nmaior concentração de fibras. \n \nA marca a ser escolhida é: \n \nA) A. \nB) B. \nC) C. \nD) D. \nE) E.",
    "alternativas": {
      "A": "A.",
      "B": "B.",
      "C": "C.",
      "D": "D."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 734,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0735",
    "numero": 2235,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "Ao iniciar suas atividades, um ascensorista re-\ngistra tanto o número de pessoas que entram \nquanto o número de pessoas que saem do ele-\nvador em cada um dos andares do edifício onde \nele trabalha. O quadro apresenta os registros do \nascensorista durante a primeira subida do tér-\nreo, de onde partem ele e mais três pessoas, ao \nquinto andar do edifício. \n \n \n \nCom base no quadro, qual é a moda do número \nde pessoas no elevador durante a subida do \ntérreo ao quinto andar? \n \nA) 2 \nB) 3 \nC) 4 \nD) 5 \nE) 6",
    "alternativas": {
      "B": "3",
      "C": "4",
      "D": "5",
      "E": "6"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 735,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0736",
    "numero": 2236,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "O censo demográfico é um levantamento esta-\ntístico que permite a coleta de várias informa-\nções. A tabela apresenta os dados obtidos pelo \ncenso demográfico brasileiro nos anos de 1940 \ne 2000, referentes à concentração da população \ntotal, na capital e no interior, nas cinco grandes \nregiões. \n \nPopulação residente, na capital e interior \nsegundo as Grandes Regiões 1940/2000 \n \n \nO valor mais próximo do percentual que descre-\nve o aumento da população nas capitais da \nRegião Nordeste é: \n \nA) 125% \nB) 231% \nC) 331% \nD) 700% \nE) 800%",
    "alternativas": {
      "C": "331%",
      "D": "700%",
      "E": "800%",
      "A": "125%"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 736,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0737",
    "numero": 2237,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "Um túnel deve ser lacrado com uma tampa de \nconcreto. A seção transversal do túnel e a tam-\npa de concreto têm contornos de um arco de \nparábola e mesmas dimensões. Para determi-\nnar o custo da obra, um engenheiro deve calcu-\nlar a área sob o arco parabólico em questão. \nUsando o eixo horizontal no nível do chão e o \neixo de simetria da parábola como eixo vertical, \nobteve a seguinte equação para a parábola: \n \ny = 9 – x2, sendo x e y medidos em metros. \nSabe-se que a área sob uma parábola como \nesta é igual a 2/3 da área do retângulo cujas \ndimensões são, respectivamente, iguais à base \ne à altura da entrada do túnel. \n \nQual é a área da parte frontal da tampa de con-\ncreto, em metro quadrado? \n \nA) 18 \nB) 20 \nC) 36 \nD) 45 \nE) 54",
    "alternativas": {
      "C": "36",
      "E": "54",
      "A": "18",
      "B": "20"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 737,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0738",
    "numero": 2238,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "Para cadastrar-se em um site, uma pessoa pre-\ncisa escolher uma senha composta por quatro \ncaracteres, sendo dois algarismos e duas letras \n(maiúsculas ou minúsculas). As letras e os alga-\nrismos podem estar em qualquer posição. Essa \npessoa sabe que o alfabeto é composto por \nvinte e seis letras e que uma letra maiúscula \ndifere da minúscula em uma senha. \n \nO número total de senhas possíveis para o ca-\ndastramento nesse site é dado por: \n \nA) 102 ∙ 262 \n \nB) 102 ∙ 522 \n \nC) 102 ∙ 522 ∙ \n4!\n2! \n \nD) 102 ∙ 262 ∙ \n4!\n2! ∙2! \n \nE) 102 ∙ 522 ∙ \n4!\n2! ∙2!",
    "alternativas": {
      "C": "102 ∙ 522 ∙ 4! 2!",
      "E": "102 ∙ 522 ∙ 4! 2! ∙2!",
      "A": "102 ∙ 262",
      "B": "102 ∙ 522"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 738,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0739",
    "numero": 2239,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "A distribuição de salários pagos em uma em-\npresa pode ser analisada destacando-se a par-\ncela do total da massa salarial que é paga aos \n10% que recebem os maiores salários. Isso \npode ser representado na forma de um gráfico \nformado por dois segmentos de reta, unidos em \num ponto P, cuja abscissa tem valor igual a 90, \ncomo ilustrado na figura. \n \nNo eixo horizontal do gráfico tem-se o percentu-\nal de funcionários, ordenados de forma crescen-\nte pelos valores de seus salários, e no eixo ver-\ntical tem-se o percentual do total da massa sala-\nrial de todos os funcionários. \n \nO Índice de Gini, que mede o grau de concen-\ntração de renda de um determinado grupo, pode \nser calculado pela razão \nA\nA+B, em que A e B \nsão as medidas das áreas indicadas no gráfico. \n \n \nA empresa tem como meta tornar seu Índice de \nGini igual ao do país, que e 0,3. Para tanto, \nprecisa ajustar os salários de modo a alterar o \npercentual que representa a parcela recebida \npelos 10% dos funcionários de maior salário em \nrelação ao total da massa salarial. \n \nPara atingir a meta desejada, o percentual deve \nser: \n \nA) 40% \nB) 20% \nC) 60% \nD) 30% \nE) 70%",
    "alternativas": {
      "C": "60%",
      "D": "30%",
      "A": "40%",
      "B": "20%"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 739,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0740",
    "numero": 2240,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "O setor de recursos humanos de uma empresa \npretende fazer contratações para adequar-se ao \nartigo 93 da Lei no. 8.213/91, que dispõe: \n \nArt. 93. A empresa com 100 (cem) ou mais em-\npregados está obrigada a preencher de 2% \n(dois por cento) a 5% (cinco por cento) dos seus \ncargos com beneficiários reabilitados ou pesso-\nas com deficiência, habilitadas, na seguinte \nproporção: \n \nI. até 200 empregados . . . . . . . . . . . . . . . . . . . . . .2%; \nII. de 201 a 500 empregados . . . . . . . . . . . . . . . . .3%; \nIII. de 507 a 1 000 empregados . . . . . . . . . . . . . . .4%; \nIV. de 1 001 em diante . . . . . . . . . . . . . . . . . . . . . 5%. \n \nConstatou-se que a empresa possui 1 200 fun-\ncionários, dos quais 10 são reabilitados ou com \ndeficiência, habilitados. \n \nPara adequar-se à referida lei, a empresa con-\ntratará apenas empregados que atendem ao \nperfil indicado no artigo 93. \nO número mínimo de empregados reabilitados \nou com deficiência, habilitados, que deverá ser \ncontratado pela empresa é: \n \nA) 74. \nB) 70. \nC) 64. \nD) 60. \nE) 53.",
    "alternativas": {
      "B": "70.",
      "C": "64.",
      "D": "60.",
      "E": "53."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 740,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0741",
    "numero": 2241,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "Uma pessoa comercializa picolés. No segundo \ndia de certo evento ela comprou 4 caixas de \npicolés, pagando R$ 16,00 a caixa com 20 pico-\nlés para revendê-los no evento. No dia anterior, \nela havia comprado a mesma quantidade de \npicolés, pagando a mesma quantia, e obtendo \num lucro de R$ 40,00 (obtido exclusivamente \npela diferença entre o valor de venda e o de \ncompra dos picolés) com a venda de todos os \npicolés que possuía.  \n \nPesquisando o perfil do público que estará pre-\nsente no evento, a pessoa avalia que será pos-\nsível obter um lucro 20% maior do que o obtido \ncom a venda no primeiro dia do evento. \n \nPara atingir seu objetivo, e supondo que todos \nos picolés disponíveis foram vendidos no se-\ngundo dia, o valor de venda de cada picolé, no \nsegundo dia, deve ser: \n \nA) R$ 0,96. \nB) R$ 1,00. \nC) R$ 1,40. \nD) R$ 1,50. \nE) R$ 1,56.",
    "alternativas": {
      "E": "R$ 1,56.",
      "A": "R$ 0,96.",
      "C": "R$ 1,40.",
      "D": "R$ 1,50."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 741,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0742",
    "numero": 2242,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "O tênis é um esporte em que a estratégia de \njogo a ser adotada depende, entre outros fato-\nres, de o adversário ser canhoto ou destro. \n \nUm clube tem um grupo de 10 tenistas, sendo \nque 4 são canhotos e 6 são destros. O técnico \ndo clube deseja realizar uma partida de exibição \nentre dois desses jogadores, porém, não pode-\nrão ser ambos canhotos. \n \nQual o número de possibilidades de escolha dos \ntenistas para a partida de exibição? \n \nA) \n10!\n2! x 8! - \n4!\n2! x 2! \n \n \nB) \n10!\n8!  - \n4!\n2! \n \nC) \n10!\n2! x 8! - 2 \n \n \nD) \n6!\n4! + 4 x 4 \n \n \nE) \n6!\n4! + 6 x 4",
    "alternativas": {
      "B": "10! 8! - 4! 2!",
      "D": "6! 4! + 4 x 4",
      "E": "6! 4! + 6 x 4",
      "A": "10! 2! x 8! - 4! 2! x 2!"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 742,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0743",
    "numero": 2243,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "O ábaco é um antigo instrumento de cálculo que \nusa notação posicional de base dez para repre-\nsentar números naturais. Ele pode ser apresen-\ntado em vários modelos, um deles é formado \npor hastes apoiadas em uma base. Cada haste \ncorresponde a uma posição no sistema decimal \ne nelas são colocadas argolas; a quantidade de \nargolas na haste representa o algarismo daque-\nla posição. Em geral, colocam-se adesivos \nabaixo das hastes com os símbolos U, D, C, M, \nDM e CM que correspondem, respectivamente, \na unidades, dezenas, centenas, unidades de \nmilhar, dezenas de milhar e centenas de milhar, \nsempre começando com a unidade na haste da \ndireita e as demais ordens do número no siste-\nma decimal nas hastes subsequentes (da direita \npara esquerda), até a haste que se encontra \nmais à esquerda. \n \nEntretanto, no ábaco da figura, os adesivos não \nseguiram a disposição usual. \n \n \n \nNessa disposição, o número que está represen-\ntado na figura é: \n \nA) 46171. \nB) 147016. \nC) 171064. \nD) 460171. \nE) 610741.",
    "alternativas": {
      "D": "460171.",
      "A": "46171.",
      "B": "147016.",
      "C": "171064."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 743,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0744",
    "numero": 2244,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "Um marceneiro está construindo um material \ndidático que corresponde ao encaixe de peças \nde madeira com 10cm de altura e formas geo-\nmétricas variadas, num bloco de madeira em \nque cada peça se posicione na perfuração com \nseu formato correspondente, conforme ilustra a \nfigura. O bloco de madeira já possui três perfu-\nrações prontas de bases distintas: uma quadra-\nda (Q), de lado 4cm, uma retangular (R), com \nbase 3cm e altura 4cm, e uma em forma de um \ntriângulo equilátero (T), de lado 6,8cm. Falta \nrealizar uma perfuração de base circular (C). \n \nO marceneiro não quer que as outras peças \ncaibam na perfuração circular e nem que a peça \nde base circular caiba nas demais perfurações \ne, para isso, escolherá o diâmetro do círculo \nque atenda a tais condições. Procurou em suas \nferramentas uma serra copo (broca com formato \ncircular) para perfurar a base em madeira, en-\ncontrando cinco exemplares, com diferentes \nmedidas de diâmetros, como segue: (l) 3,8cm; \n(ll) 4,7cm; (lll) 5,6cm; (IV) 7,2cm e (V) 9,4cm. \n \n \n \nConsidere 1,4 e 1,7 como aproximações para \n√2 e √3, respectivamente. \n \nPara que seja atingido o seu objetivo, qual dos \nexemplares de serra copo o marceneiro deverá \nescolher? \n \nA) I \nB) II \nC) III \nD) IV \nE) V",
    "alternativas": {
      "C": "III",
      "D": "IV",
      "A": "I",
      "B": "II"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 744,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0745",
    "numero": 2245,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "Em um exame, foi feito o monitoramento dos \nníveis de duas substâncias presentes (A e B) na \ncorrente sanguínea de uma pessoa, durante um \nperíodo de 24 h, conforme o resultado apresen-\ntado na figura. Um nutricionista, no intuito de \nprescrever uma dieta para essa pessoa, anali-\nsou os níveis dessas substâncias, determinando \nque, para uma dieta semanal eficaz, deverá ser \nestabelecido um parâmetro cujo valor será dado \npelo número de vezes em que os níveis de A e \nde B forem iguais, porém, maiores que o nível \nmínimo da substância A durante o período de \nduração da dieta. \n \n \nConsidere que o padrão apresentado no resul-\ntado do exame, no período analisado, se repita \npara os dias subsequentes. \n \nO valor do parâmetro estabelecido pelo nutricio-\nnista, para uma dieta semanal, será igual a: \n \nA) 28. \nB) 21. \nC) 2. \nD) 7. \nE) 14.",
    "alternativas": {
      "C": "2.",
      "D": "7.",
      "E": "14.",
      "B": "21."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 745,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0746",
    "numero": 2246,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "Um paciente necessita de reidratação endove-\nnosa feita por meio de cinco frascos de soro \ndurante 24 h. Cada frasco tem um volume de \n800 mL de soro. Nas primeiras quatro horas, \ndeverá receber 40% do total a ser aplicado. \nCada mililitro de soro corresponde a 12 gotas. \n \nO número de gotas por minuto que o paciente \ndeverá receber após as quatro primeiras horas \nserá: \n \nA) 16. \nB) 20. \nC) 24. \nD) 34. \nE) 40.",
    "alternativas": {
      "A": "16.",
      "C": "24.",
      "D": "34.",
      "E": "40."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 746,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0747",
    "numero": 2247,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "É comum os artistas plásticos se apropriarem \nde entes matemáticos para produzirem, por \nexemplo, formas e imagens por meio de mani-\npulações. Um artista plástico, em uma de suas \nobras, pretende retratar os diversos polígonos \nobtidos pelas intersecções de um plano com \numa pirâmide regular de base quadrada. \n \nSegundo a classificação dos polígonos, quais \ndeles são possíveis de serem obtidos pelo artis-\nta plástico? \nA) Quadrados, apenas. \nB) Triângulos e quadrados, apenas. \nC) Triângulos, quadrados e trapézios, apenas. \nD) Triângulos, quadrados, trapézios e quadrilá-\nteros irregulares, apenas. \nE) Triângulos, quadrados, trapézios, quadriláte-\nros irregulares e pentágonos, apenas.",
    "alternativas": {
      "E": "Triângulos, quadrados, trapézios, quadriláte- ros irregulares e pentágonos, apenas.",
      "A": "Quadrados, apenas.",
      "B": "Triângulos e quadrados, apenas.",
      "D": "Triângulos, quadrados, trapézios e quadrilá- teros irregulares, apenas."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 747,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0748",
    "numero": 2248,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "Um reservatório é abastecido com água por \numa torneira e um ralo faz a drenagem da água \ndesse reservatório. Os gráficos representam as \nvazões Q, em litro por minuto, do volume de \nágua que entra no reservatório pela torneira e \ndo volume que sai pelo ralo, em função do tem-\npo t, em minuto. \n \n \n \nEm qual intervalo de tempo, em minuto, o reser-\nvatório tem uma vazão constante de enchimen-\nto? \n \nA) De 0 a 10. \nB) De 5 a 10. \nC) De 5 a 15. \nD) De 15 a 25. \nE) De 0 a 25.",
    "alternativas": {
      "C": "De 5 a 15.",
      "E": "De 0 a 25.",
      "A": "De 0 a 10.",
      "B": "De 5 a 10."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 748,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0749",
    "numero": 2249,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "O LlRAa, Levantamento Rápido do Índice de \nInfestação por Aedes aegypti, consiste num \nmapeamento da infestação do mosquito Aedes \naegypti. O LlRAa é dado pelo percentual do \nnúmero de imóveis com focos do mosquito, \nentre os escolhidos de uma região em avalia-\nção. \n \nO serviço de vigilância sanitária de um municí-\npio, no mês de outubro do ano corrente, anali-\nsou o LlRAa de cinco bairros que apresentaram \no maior índice de infestação no ano anterior. Os \ndados obtidos para cada bairro foram: \nI. 14 imóveis com focos de mosquito em 400 \nimóveis no bairro; \nII. 6 imóveis com focos de mosquito em 500 \nimóveis no bairro; \nIII. 13 imóveis com focos de mosquito em 520 \nimóveis no bairro; \nIV. 9 imóveis com focos de mosquito em 360 \nimóveis no bairro; \nV. 15 imóveis com focos de mosquito em 500 \nimóveis no bairro. \n \nO setor de dedetização do município definiu que \no direcionamento das ações de controle inicia-\nrão pelo bairro que apresentou o maior índice \ndo LlRAa. \n \nAs ações de controle iniciarão pelo bairro: \n \nA) I. \nB) II. \nC) III. \nD) IV. \nE) V.",
    "alternativas": {
      "A": "I.",
      "B": "II.",
      "C": "III.",
      "D": "IV."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 749,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0750",
    "numero": 2250,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "Uma família resolveu comprar um imóvel num \nbairro cujas ruas estão representadas na figura. \nAs ruas com nomes de letras são paralelas en-\ntre si e perpendiculares às ruas identificadas \ncom números. Todos os quarteirões são qua-\ndrados, com as mesmas medidas, e todas as \nruas têm a mesma largura, permitindo caminhar \nsomente nas direções vertical e horizontal. Des-\nconsidere a largura das ruas. \n \n \n \nA família pretende que esse imóvel tenha a \nmesma distância de percurso até o local de \ntrabalho da mãe, localizado na rua 6 com a rua \nE, o consultório do pai, na rua 2 com a rua E, e \na escola das crianças, na rua 4 com a rua A. \nCom base nesses dados, o imóvel que atende \nas pretensões da família deverá ser localizado \nno encontro das ruas: \n \nA) 3 e C. \nB) 4 e C. \nC) 4 e D. \nD) 4 e E. \nE) 5 e C.",
    "alternativas": {
      "B": "4 e C.",
      "C": "4 e D.",
      "D": "4 e E.",
      "E": "5 e C."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 750,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0751",
    "numero": 2251,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "Um senhor, pai de dois filhos, deseja comprar \ndois terrenos, com áreas de mesma medida, um \npara cada filho. Um dos terrenos visitados já \nestá demarcado e, embora não tenha um forma-\nto convencional (como se observa na Figura B), \nagradou ao filho mais velho e, por isso, foi com-\nprado. O filho mais novo possui um projeto ar-\nquitetônico de uma casa que quer construir, \nmas, para isso, precisa de um terreno na forma \nretangular (como mostrado na Figura A) cujo \ncomprimento seja 7 m maior do que a largura. \n \n \n \nPara satisfazer o filho mais novo, esse senhor \nprecisa encontrar um terreno retangular cujas \nmedidas, em metro, do comprimento e da largu-\nra sejam iguais, respectivamente, a: \n \nA) 7,5 e 14,5. \nB) 9,0 e 16,0. \nC) 9,3 e 16,3. \nD) 10,0 e 17,0. \nE) 13,5 e 20,5.",
    "alternativas": {
      "B": "9,0 e 16,0.",
      "D": "10,0 e 17,0.",
      "E": "13,5 e 20,5.",
      "A": "7,5 e 14,5."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 751,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0752",
    "numero": 2252,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "Preocupada com seus resultados, uma empresa \nfez um balanço dos lucros obtidos nos últimos \nsete meses, conforme dados do quadro. \n \n \n \nAvaliando os resultados, o conselho diretor da \nempresa decidiu comprar, nos dois meses sub-\nsequentes, a mesma quantidade de matéria-\nprima comprada no mês em que o lucro mais se \naproximou da média dos lucros mensais dessa \nempresa nesse período de sete meses. \n \nNos próximos dois meses, essa empresa deve-\nrá comprar a mesma quantidade de matéria-\nprima comprada no mês: \n \nA) I. \nB) II. \nC) IV. \nD) V. \nE) VII.",
    "alternativas": {
      "B": "II.",
      "D": "V.",
      "E": "VII.",
      "A": "I."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 752,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0753",
    "numero": 2253,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "Densidade absoluta (d) é a razão entre a massa \nde um corpo e o volume por ele ocupado. Um \nprofessor propôs à sua turma que os alunos \nanalisassem a densidade de três corpos: dA, dB, \ndC. Os alunos verificaram que o corpo A possuía \n1,5 vez a massa do corpo B e esse, por sua \nvez, tinha ¾ da massa do corpo C. Observaram, \nainda, que o volume do corpo A era o mesmo \ndo corpo B e 20% maior do que o volume do \ncorpo C. \n \nApós a análise, os alunos ordenaram correta-\nmente as densidades desses corpos da seguin-\nte maneira: \n \nA) dB < dA < dC \nB) dB = dA < dC \nC) dC < dB = dA \nD) dB < dC < dA \nE) dc < dB < dA",
    "alternativas": {
      "A": "dB < dA < dC",
      "B": "dB = dA < dC",
      "C": "dC < dB = dA",
      "E": "dc < dB < dA"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 753,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0754",
    "numero": 2254,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "No tanque de um certo carro de passeio cabem \naté 50 L de combustível, e o rendimento médio \ndeste carro na estrada é de 15 km/L de combus-\ntível. Ao sair para uma viagem de 600km o mo-\ntorista observou que o marcador de combustível \nestava exatamente sobre uma das marcas da \nescala divisória do medidor, conforme figura a \nseguir. \n \n \nComo o motorista conhece o percurso, sabe \nque existem, até a chegada a seu destino, cinco \npostos de abastecimento de combustível, locali-\nzados a 150 km, 187 km, 450 km, 500 km e 570 \nkm do ponto de partida. \nQual a máxima distância, em quilômetro, que \npoderá percorrer até ser necessário reabastecer \no veículo, de modo a não ficar sem combustível \nna estrada? \n \nA) 570 \nB) 500 \nC) 450 \nD) 187 \nE) 150",
    "alternativas": {
      "A": "570",
      "B": "500",
      "C": "450",
      "D": "187"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 754,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0755",
    "numero": 2255,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "Sob a orientação de um mestre de obras, João \ne Pedro trabalharam na reforma de um edifício. \nJoão efetuou reparos na parte hidráulica nos \nandares 1, 3, 5, 7, e assim sucessivamente, de \ndois em dois andares. Pedro trabalhou na parte \nelétrica nos andares 1, 4, 7, 10, e assim suces-\nsivamente, de três em três andares. Coincidente \nmente, terminaram seus trabalhos no último \nandar.  \n \nNa conclusão da reforma, o mestre de obras \ninformou, em seu relatório, o número de anda-\nres do edifício. Sabe-se que, ao longo da exe-\ncução da obra, em exatamente 20 andares, \nforam realizados reparos nas partes hidráulica e \nelétrica por João e Pedro. \n \nQual é o número de andares desse edifício? \n \nA) 40 \nB) 60 \nC) 100 \nD) 115 \nE) 120",
    "alternativas": {
      "B": "60",
      "C": "100",
      "D": "115",
      "E": "120"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 755,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0756",
    "numero": 2256,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "Em uma cidade será construída uma galeria \nsubterrânea que receberá uma rede de canos \npara o transporte de água de uma fonte (F) até \no reservatório de um novo bairro (B). \n \nApós avaliações, foram apresentados dois pro-\njetos para o trajeto de construção da galeria: um \nsegmento de reta que atravessaria outros bair-\nros ou uma semicircunferência que contornaria \nesses bairros, conforme ilustrado no sistema de \ncoordenadas xOy da figura, em que a unidade \nde medida nos eixos é o quilômetro. \n \nEstudos de viabilidade técnica mostraram que, \npelas características do solo, a construção de 1 \nm de galeria via segmento de reta demora 1,0 h, \nenquanto que 1 m de construção de galeria via \nsemicircunferência demora 0,6 h. \n \nHá urgência em disponibilizar água para esse \nbairro. \n \nUse 3 como aproximação para 𝜋 e 1,4 como \naproximação para √2. \n \nO menor tempo possível, em hora, para conclu-\nsão da construção da galeria, para atender às \nnecessidades de água do bairro, é de: \n \nA) 1260.  \nB) 2520.  \nC) 2800. \nD) 3600.  \nE) 4000.",
    "alternativas": {
      "D": "3600.",
      "E": "4000.",
      "A": "1260.",
      "B": "2520."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 756,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0758",
    "numero": 2258,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "Diante da hipótese do comprometimento da \nqualidade da água retirada do volume morto de \nalguns sistemas hídricos, os técnicos de um \nlaboratório decidiram testar cinco tipos de filtros \nde água. Dentre esses, os quatro com melhor \ndesempenho serão escolhidos para futura co-\nmercialização. \n \nNos testes, foram medidas as massas de agen-\ntes contaminantes, em miligrama, que não são \ncapturados por cada filtro em diferentes perío-\ndos, em dia, como segue: \n \n• Filtro 1 (F1): 18 mg em 6 dias; \n• Filtro 2 (F2): 15 mg em 3 dias; \n• Filtro 3 (F3): 18 mg em 4 dias; \n• Filtro 4 (F4): 6 mg em 3 dias; \n• Filtro 5 (F5): 3 mg em 2 dias. \n \nAo final, descarta-se o filtro com a maior razão \nentre a medida da massa de contaminantes não \ncapturados e o número de dias, o que corres-\nponde ao de pior desempenho. \n \nO filtro descartado é o: \n \nA) F1. \nB) F2. \nC) F3. \nD) F4. \nE) F5.",
    "alternativas": {
      "A": "F1.",
      "B": "F2.",
      "C": "F3.",
      "E": "F5."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 758,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0759",
    "numero": 2259,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "Em 2011, um terremoto de magnitude 9,0 na \nescala Richter causou um devastador tsunami \nno Japão, provocando um alerta na usina nu-\nclear de Fukushima. \n \nEm 2013, outro terremoto, de magnitude 7,0 na \nmesma escala, sacudiu Sichuan (sudoeste da \nChina), deixando centenas de mortos e milhares \nde feridos. A magnitude de um terremoto na \nescala Richter pode ser calculada por: \n \nM = \n2\n3 log (\nE\nE0) \n \nSendo E a energia, em kWh, liberada pelo ter-\nremoto e E0 uma constante real positiva. Consi-\ndere que E1 e E2 representam as energias libe-\nradas nos terremotos ocorridos no Japão e na \nChina, respectivamente. \n \nQual a relação entre E1 e E2? \n \nA) E1 = E2 + 2 \n \nB) E1 = 102 ∙ E2 \n \nC) E1 = 103 ∙ E2 \n \nD) E1 = 10\n9\n7 ∙ E2 \n \nE) E1 = \n9\n7 ∙ E2",
    "alternativas": {
      "A": "E1 = E2 + 2",
      "B": "E1 = 102 ∙ E2",
      "C": "E1 = 103 ∙ E2",
      "D": "E1 = 10 9 7 ∙ E2"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 759,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0760",
    "numero": 2260,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "Em regiões agrícolas, é comum a presença de \nsilos para armazenamento e secagem da pro-\ndução de grãos, no formato de um cilindro reto, \nsobreposta por um cone, e dimensões indicadas \nna figura. O silo fica cheio e o transporte dos \ngrãos é feito em caminhões de carga cuja capa-\ncidade é de 20 m3. Uma região possui um silo \ncheio e apenas um caminhão para transportar \nos grãos para a usina de beneficiamento. \n \n \n \nUtilize 3 como aproximação para 𝜋. \nO número mínimo de viagens que o caminhão \nprecisará fazer para transportar todo o volume \nde grãos armazenados no silo é: \n \nA) 6.  \nB) 16.  \nC) 17. \nD) 18.  \nE) 21.",
    "alternativas": {
      "C": "17.",
      "D": "18.",
      "E": "21.",
      "B": "16."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 760,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0761",
    "numero": 2261,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "Em uma empresa de móveis, um cliente enco-\nmenda um guarda-roupa nas dimensões 220 cm \nde altura, 120 cm de largura e 50 cm de profun-\ndidade. Alguns dias depois, o projetista, com o \ndesenho elaborado na escala 1:8, entra em \ncontato com o cliente para fazer sua apresenta-\nção. \n \nNo momento da impressão, o profissional per-\ncebe que o desenho não caberia na folha de \npapel que costumava usar. Para resolver o pro-\nblema, configurou a impressora para que a figu-\nra fosse reduzida em 20%. \n \nA altura, a largura e a profundidade do desenho \nimpresso para a apresentação serão, respecti-\nvamente, \n \nA) 22,00 cm, 12,00 cm e 5,00 cm. \nB) 27,50 cm, 15,00 cm e 6,25 cm. \nC) 34,37 cm, 18,75 cm e 7,81 cm. \nD) 35,20 cm, 19,20 cm e 8,00 cm. \nE) 44,00 cm, 24,00 cm e 10,00 cm.",
    "alternativas": {
      "A": "22,00 cm, 12,00 cm e 5,00 cm.",
      "C": "34,37 cm, 18,75 cm e 7,81 cm.",
      "D": "35,20 cm, 19,20 cm e 8,00 cm.",
      "E": "44,00 cm, 24,00 cm e 10,00 cm."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 761,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0762",
    "numero": 2262,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "A London Eye é urna enorme roda-gigante na \ncapital inglesa. Por ser um dos monumentos \nconstruídos para celebrar a entrada do terceiro \nmilênio, ela também é conhecida como Roda do \nMilênio. Um turista brasileiro, em visita à Ingla-\nterra, perguntou a um londrino o diâmetro (des-\ntacado na imagem) da Roda do Milênio e ele \nrespondeu que ele tem 443 pés. \n \n \n \nNão habituado com a unidade pé, e querendo \nsatisfazer sua curiosidade, esse turista consul-\ntou um manual de unidades de medidas e cons-\ntatou que 1 pé equivale a 12 polegadas, e que 1 \npolegada equivale a 2,54 cm. Após alguns cál-\nculos de conversão, o turista ficou surpreendido \ncom o resultado obtido em metros. \n \nQual a medida que mais se aproxima do diâme-\ntro da Roda do Milênio, em metro? \n \nA) 53 \nB) 94 \nC) 113 \nD) 135 \nE) 145",
    "alternativas": {
      "E": "145",
      "A": "53",
      "B": "94",
      "D": "135"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 762,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0764",
    "numero": 2264,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "Para garantir a segurança de um grande evento \npúblico que terá início às 4 h da tarde, um orga-\nnizador precisa monitorar a quantidade de pes-\nsoas presentes em cada instante. Para cada \n2000 pessoas se faz necessária a presença de \num policial. Além disso, estima-se uma densi-\ndade de quatro pessoas por metro quadrado de \nárea de terreno ocupado. Às 10 h da manhã, o \norganizador verifica que a área de terreno já \nocupada equivale a um quadrado com lados \nmedindo 500 m. Porém, nas horas seguintes, \nespera-se que o público aumente a uma taxa de \n120000 pessoas por hora até o início do evento, \nquando não será mais permitida a entrada de \npúblico. \n \nQuantos policiais serão necessários no início do \nevento para garantir a segurança? \n \nA) 360 \nB) 485 \nC) 560 \nD) 740 \nE) 860",
    "alternativas": {
      "B": "485",
      "C": "560",
      "D": "740",
      "E": "860"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 764,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0765",
    "numero": 2265,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "A permanência de um gerente em uma empresa \nestá condicionada à sua produção no semestre. \nEssa produção é avaliada pela média do lucro \nmensal do semestre. Se a média for, no mínimo, \nde 30 mil reais, o gerente permanece no cargo, \ncaso contrário, ele será despedido. O quadro \nmostra o lucro mensal, em milhares de reais, \ndessa empresa, de janeiro a maio do ano em \ncurso. \n \n \n \nQual deve ser o lucro mínimo da empresa no \nmês de junho, em milhares de reais, para o \ngerente continuar no cargo no próximo semes-\ntre? \n \nA) 26  \nB) 29  \nC) 30  \nD) 31  \nE) 35",
    "alternativas": {
      "C": "30",
      "D": "31",
      "E": "35",
      "B": "29"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2016.1",
    "numeroOriginal": 765,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0766",
    "numero": 2266,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "Pretende-se construir um mosaico com o forma-\nto de um triângulo retângulo, dispondo-se de \ntrês peças, sendo duas delas triângulos retân-\ngulos congruentes e a terceira um triângulo \nisósceles. A figura apresenta cinco mosaicos \nformados por três peças. \n \n \nNa figura, o mosaico que tem as características \ndaquele que se pretende construir é o: \n \nA) 1. \nB) 2. \nC) 3. \nD) 4. \nE) 5.",
    "alternativas": {
      "A": "1.",
      "B": "2.",
      "D": "4.",
      "E": "5."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 766,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0767",
    "numero": 2267,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "Uma caixa contém uma cédula de R$ 5,00, uma \nde R$ 20,00 e duas de R$ 50,00 de modelos \ndiferentes. Retira-se aleatoriamente uma cédula \ndessa caixa, anota-se o seu valor e devolve-se \na cédula à caixa. Em seguida, repete-se o pro-\ncedimento anterior. A probabilidade de que a \nsoma dos valores anotados seja pelo menos \nigual a R$ 55,00 é: \n \nA) 1/2 \nB) 1/4 \nC) 3/4 \nD) 2/9 \nE) 5/9",
    "alternativas": {
      "A": "1/2",
      "B": "1/4",
      "C": "3/4",
      "E": "5/9"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 767,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0768",
    "numero": 2268,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "Uma empresa registrou seu desempenho em \ndeterminado ano por meio do gráfico, com da-\ndos mensais do total de vendas e despesas. \nO lucro mensal é obtido pela subtração entre o \ntotal de vendas e despesas, nesta ordem. Quais \nos três meses do ano em que foram registrados \nos maiores lucros? \n \nA) Julho, setembro e dezembro. \nB) Julho, setembro e novembro. \nC) Abril, setembro e novembro. \nD) Janeiro, setembro e dezembro. \nE) Janeiro, abril e junho.",
    "alternativas": {
      "E": "Janeiro, abril e junho.",
      "A": "Julho, setembro e dezembro.",
      "B": "Julho, setembro e novembro.",
      "C": "Abril, setembro e novembro."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 768,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0769",
    "numero": 2269,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "Um casal, ambos com 30 anos de idade, pre-\ntende fazer um plano de previdência privada. A \nseguradora pesquisada, para definir o valor do \nrecolhimento mensal, estima a probabilidade de \nque pelo menos um deles esteja vivo daqui a 50 \nanos, tornando por base dados da população, \nque indicam que 20% dos homens e 30% das \nmulheres de hoje alcançarão a idade de 80 \nanos. Qual é essa probabilidade? \n \nA) 50% \nB) 44% \nC) 38% \nD) 25% \nE) 6%",
    "alternativas": {
      "D": "25%",
      "A": "50%",
      "B": "44%",
      "C": "38%"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 769,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  }
];